import { Outlet } from 'react-router-dom'
import { Sidebar } from '../components/shared/Sidebar'

/**
 * Layout raíz de la app autenticada.
 * Sidebar fijo a la izquierda + contenido scrollable a la derecha.
 */
export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col overflow-hidden bg-surface md:h-screen md:flex-row">
      <Sidebar />
      <main className="flex min-w-0 flex-1 flex-col overflow-y-auto bg-surface">
        <div className="page-enter flex-1">
          <Outlet />
        </div>
        <footer className="shrink-0 px-6 py-4 text-center">
          <p className="text-[11px] text-text-disabled">
            Desarrollado por{' '}
            <a
              href="https://codelan.cl"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-text-muted transition-colors hover:text-brand"
            >
              codelan.cl
            </a>
          </p>
        </footer>
      </main>
    </div>
  )
}
